<template>
  <transition name="left">
    <div class="contacto-container" v-if="abrir">
      <div class="contacto-close" @click="abrir=false"></div>
      <p class="contacto-title" @click="abrir=false">Información de contacto</p>
      <img class="contacto-title-arrow" :src="require('@/assets/img/arrow_white_right.png')">
      <p class="contacto-campo-title">TELÉFONO</p>
      <input class="contacto-campo-input" type="text" ref="telefono"
      v-bind:class="{ 'error-input': errorTelefono }">
      <p class="contacto-campo-title">EMAIL</p>
      <input class="contacto-campo-input" type="text" ref="email"
      v-bind:class="{ 'error-input': errorEmail }">
      <textarea
        class="contacto-campo-textarea"
        cols="30"
        rows="10"
        placeholder="Escriba su consulta aquí..."
        ref="consulta"
        v-bind:class="{ 'error-input': errorConsulta }"
      ></textarea>
      <button v-show="!enviando" class="contacto-enviar" @click="enviar()">ENVIAR</button>
      <button v-show="enviando" class="contacto-enviar" >ENVIANDO</button>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "contacto",
  data() {
    return {
      abrir: false,
      errorTelefono: false,
      errorEmail: false,
      errorConsulta: false,
      enviando: false
    };
  },
  created() {
    Event.$on("abrir-contacto", () => (this.abrir = true));
  },
  methods: {
    enviar() {
      this.enviando = true;

      var enviar = true;

      var telefono = this.$refs.telefono.value;
      var email = this.$refs.email.value;
      var consulta = this.$refs.consulta.value;

      if(telefono == null || telefono.replace(/\s/g, '').length == 0){
        this.errorTelefono = true;
        enviar = false;
      }else{
        this.errorTelefono = false;
      }
      if(email == null || email.replace(/\s/g, '').length == 0){
        this.errorEmail = true;
        enviar = false;
      }else{
         this.errorEmail = false;
      }
      if(consulta == null || consulta.replace(/\s/g, '').length == 0){
        this.errorConsulta = true;
        enviar = false;
      }else{
        this.errorConsulta = false;
      }
      if(enviar == true){
        var that = this;
        var json = {
          email: email,
          telefono: telefono,
          consulta: consulta
        }
        axios
        .put(window.location.href + "api/contacto", json)
        .then(function() {
          that.$refs.telefono.value = "";
          that.$refs.email.value = "";
          that.$refs.consulta.value = "";
          that.enviando = false;
          that.abrir = false;
        })
        .catch(function() {
          that.enviando = false;
          that.abrir = false;
        });
      }else{
        this.enviando = false;
      }
    }
  },
};
</script>

<style>
@import "../assets/css/contacto.css";
</style>
